
import ApiGenericServicesData from 'services/ApiGenericServicesData';

export default class HabilitacionDeFallecidos extends ApiGenericServicesData{
    constructor(){
        super("habilitacion");
    }
    consultarPadron(nroboleta) { return this.customGET("consultarPadron/"+nroboleta); }
    list(nroboleta) { return this.customGET("list/"+nroboleta); }
    obtenerDocumentoHabilitacion(id) { return this.customGET("obtenerDocumentoHabilitacion/"+id); }
    update(data) { return this.customPUTModify("update",data); }
    // subirDocumentoInvestigacion(data) { return this.customPOST("subirDocumentoInvestigacion", data); }
}